import "../css/login.page.css";

$(() => {
  $("#login-form").on("submit", function () {
    // Clear the error message
    $("#login-error-msg").text("");

    if ($(this).valid()) {
      // Check if the form is valid
      $("#login-submit-btn").prop("disabled", true); // Disable the submit button
    }
  });
});
